const isContainArray = (arr1, arr2) => {
  return arr1.some((r) => arr2.indexOf(r) >= 0);
};

export default isContainArray;
